import { HttpClient, HttpErrorResponse, HttpEventType } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { IFileUploader, UploadFileResult, UploadProgress } from "sabis-components2";

@Injectable({
  providedIn: 'root'
})
export class CareersUploader implements IFileUploader {

  constructor(private _http: HttpClient, @Inject('API_URL') private _apiUrl: string) { }

  public uploadFile(file: File, path: string, fileName: string, abortSignal: AbortSignal
    , progress: (p: UploadProgress) => void
    , complete: (p: UploadFileResult) => void): void {


    let fileToUpload = file;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('path', path);
    formData.append('fileName', fileName);

    let url: string = `${this._apiUrl}/files`;
    this._http.post(url, formData, { reportProgress: true, observe: 'events' })
      .subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress) {
            let progressValue = Math.round(100 * event.loaded / event.total!);
            console.log(progressValue);
            progress({
              uploadedPercentage: progressValue
            });
          }
          else if (event.type === HttpEventType.Response) {
            let result: UploadFileResult = event.body as UploadFileResult;
            complete(result);
          }
        },
        error: (err: HttpErrorResponse) => console.log(err)
      });
  }
}
